export default __webpack_public_path__ + "static/media/plain-sticker-A.1ea702a2.png";